import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';

import { EventTypes } from 'src/app/core/constants/event-types';
import {
  CustomResultOfPaginatedListOfGetInboxGroupsWithPaginationDto,
  GetInboxGroupsWithPaginationDto,
  PaginatedListOfGetInboxGroupsWithPaginationDto,
} from '../../../core/api/models';
import { InboxGroupsService } from '../../../core/api/services/inbox-groups.service';
import { AppDomService } from '../../../core/services/dom.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { InboxGroupsFormComponent } from './inbox-groups-form/inbox-groups-form.component';

@Component({
    selector: 'app-inbox-groups',
    templateUrl: './inbox-groups.component.html',
    standalone: false
})
export class InboxGroupsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'inboxGroups';

  modelWithPagination$: Observable<PaginatedListOfGetInboxGroupsWithPaginationDto>;
  items$: Observable<Array<GetInboxGroupsWithPaginationDto>>;
  formPageConfig: FormPageConfig<GetInboxGroupsWithPaginationDto> = {};

  // public MainSettingsDisplay: typeof MainSettingsDisplay = MainSettingsDisplay;

  //#endregion

  constructor(protected currentService: InboxGroupsService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.setPageService(this.currentService, 'inboxGroupsCreateInboxGroupGet');
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.name, name: 'name', hasSearch: true },
      {
        title: this.localizer.organizationName,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfGetInboxGroupsWithPaginationDto> {
    //  if (!this.isSuperAdmin) return;
    return this.currentService.inboxGroupsGetInboxGroupsWithPagination({
      body: this.getBaseModelWithPaginationParams(),
    });
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .inboxGroupsDeleteInboxGroup({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .inboxGroupsUpdateInboxGroupGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserverFormModal);
  }

  //#endregion

  openCreateFormModal() {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}addTitle`,
        isEdit: false,
        pageVocab: 'pages.inboxGroups.form.',
      };

      const modalResult = this.dialogService.openModal({
        component: InboxGroupsFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(() => (this.pageConfig.isVisibleForm = undefined)),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  openEditFormModal(model) {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}editTitle`,
        model: {
          id: model.id,
          name: model.name,
        },
        isEdit: true,
        pageVocab: 'pages.inboxGroups.form.',
      };

      const modalResult = this.dialogService.openModal({
        component: InboxGroupsFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }
}
